import ReusablePortlets from './ReusablePortlets';

const portletInstances = new Map();

const PortletPool = {
  set(portletId, instance) {
    if (ReusablePortlets.includes(portletId)) {
      return;
    }
    portletInstances.set(portletId, instance);
  },
  get(portletId) {
    return portletInstances.get(portletId);
  },
  remove(portletId) {
    portletInstances.delete(portletId);
  },
};
export default PortletPool;
